/** Штатный шэринг Telegram: выбор чата и превью по og-тегам страницы (docs/telegram.md §8). */
const SHARE_ENDPOINT = 'https://t.me/share/url'

/**
 * Ссылка на штатный экран «Поделиться» Telegram.
 *
 * Собирается строкой, а **не** через `URLSearchParams`, и это единственная причина, по которой
 * функция вообще существует. `URLSearchParams` кодирует по правилам HTML-формы
 * (`application/x-www-form-urlencoded`), где пробел — это `+`. Telegram разбирает адрес по
 * правилам обычного URL и `+` обратно в пробел не превращает: приглашение улетало в чат как
 * «Захар+хочет+чтобы+Луня+приглядывала+и+за+тобой+🐾».
 *
 * `encodeURIComponent` кодирует пробел как `%20` — его понимают обе стороны. Заодно он
 * правильно поступает с переносами строк (`%0A`), эмодзи (UTF-8 по байтам) и со знаками
 * `?`, `&`, `#` внутри самой ссылки, которые иначе разрезали бы запрос пополам.
 *
 * Порядок параметров тот же, что в документации Telegram: сначала `url`, потом `text`.
 */
export function buildShareUrl(params: { text: string; url: string }): string {
  const query = `url=${encodeURIComponent(params.url)}&text=${encodeURIComponent(params.text)}`

  return `${SHARE_ENDPOINT}?${query}`
}
